import { createComponent } from '@lit/react';
import React from 'react';
import { SheriffEventName } from './types';
import { SDSDialog } from '../sds-dialog/sds-dialog';

export const SDSDialogWrapper = createComponent({
	tagName: 'sds-dialog',
	elementClass: SDSDialog,
	react: React,
	events: {
		onClose: 'sds-close' as SheriffEventName,
	},
});
